import { useSelector } from "react-redux";

import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import { useContext, useEffect, useState } from "react";
import P from "components/P";
import Center from "layouts/wrapper/Center";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import Dummy from "components/Dummy";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";
import { useDispatch } from "react-redux";
import MobileCartProductCard from "../main/cartproductcard/MobileCartProductCard";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Inline from "layouts/container/Inline";
import BackButton from "components/buttons/BackButton";
import CustomIcon from "components/icons/CustomIcon";
import { useNavigate, useParams } from "react-router-dom";
import { requester } from "App";
import { toast } from "react-toastify";
import { AuthContext } from "providers/AuthProvider";

function MobileCartList({ paymentModalClick }) {
    const { id } = useParams();
    const navigate = useNavigate();
    const cartData = useSelector((state) => state.cart.products);
    const [cartList, setCartList] = useState([]);
    const [total, setTotal] = useState(0);
    const { isMobile } = useContext(BrowserDetectContext);
    const { userId } = useContext(AuthContext);
    const dispatch = useDispatch();

    useEffect(() => {
        if (cartData) {
            setCartList(cartData);

        }
        const newTotal = cartData.reduce((acc, item) => acc + item.quantity * item.price, 0);
        setTotal(newTotal);
    }, [cartData])
    useEffect(() => {
        const totalPrice = cartList.reduce((total, item) => {
            return total + (item.quantity * item.price);
        }, 0);
        setTotal(totalPrice);
        
    }, [cartList]);

    const cartResetClick = () => {
        dispatch(CartReducer.actions.reset());
    }
    const onSettingBtnClick = () => {
        navigate(`/ws/${id}/mobile/setting`);
    };

    const onPaymentClick = () => {
        const newTotal = cartData.reduce((acc, item) => acc + item.quantity * item.price, 0);
        const extractedData = cartList.map(item => ({
            locationNo: item.locationNo,
            quantity: item.quantity,
            deviceId: item.deviceId
        }));
        
        // const extractedValues = extractedData.map(item => [item.locationNo, item.quantity]);
        const extractedValues = extractedData.map(item => {
            const deviceIdSuffix = item.deviceId ? item.deviceId.slice(-3) : '';
            return [item.locationNo, item.quantity, deviceIdSuffix];
        });
        const jsonMachineData = extractedValues;
        const jsonMachineString = JSON.stringify(jsonMachineData);
        const base64EncodedString = btoa(jsonMachineString);

        let data = {
            orderProducts: cartData,
            amount: newTotal,
            storeCode: id,
            machineData: base64EncodedString,
            returnUrl: 'https://puffuapp.com/ws/5/mobile'
        };

        // requester.purchaseOrder를 프로미스로 감싸기
        if (cartData && cartData.length > 0) {

            requester.testPaymentRequest(data, (result) => {

                let ready = result.data;

                if (result.code === 0) {

                    let ready = result.data;
                    requester.testPayment(ready, (result) => {
                        if (result.code === 0) {
                            let paymentResult = result.data;

                            const trxId = paymentResult.link.trxId;
                            const trackId = paymentResult.link.trackId;
                            const amount = paymentResult.link.amount;
                            const storeCode = paymentResult.link.udf1;
                            const deviceCode = window.BRIDGE && window.BRIDGE.getDeviceCode ? window.BRIDGE.getDeviceCode() : "";


                            // const extractedData = cartList.map(item => ({
                            //     locationNo: item.locationNo,
                            //     quantity: item.quantity,

                            // }));
                            // const extractedValues = extractedData.map(item => [item.locationNo, item.quantity]);
                            const extractedData = cartList.map(item => ({
                                locationNo: item.locationNo,
                                quantity: item.quantity,
                                deviceId: item.deviceId
                            }));
                            
                            // const extractedValues = extractedData.map(item => [item.locationNo, item.quantity]);
                            const extractedValues = extractedData.map(item => {
                                const deviceIdSuffix = item.deviceId ? item.deviceId.slice(-3) : '';
                                return [item.locationNo, item.quantity, deviceIdSuffix];
                            });
                            
                            const jsonData = extractedValues;
                            const jsonString = JSON.stringify(jsonData);
                            const base64EncodedString = btoa(jsonString);
                            const param = `data=${base64EncodedString}`;




                            //테스트용 
                            let productData = {
                                id: trackId,
                                totalAmount: amount,
                                usedPoints: 0,
                                userId: userId
                            }

                            requester.changeWaitingForProducts(productData, (result) => {
                                if (result.code === 0) {
                                    window.location.replace(`/ws/${storeCode}/payment/puffuOrder/complete?data=${param}&deviceCode=${deviceCode}`);
                                } else if (result.code === -1) {

                                }
                            })

                            // navigate(`/ws/${id}/payment/puffuOrder/complete?${param}&trxId=${trxId}&trackId=${trackId}&amount=${amount}&storeCode=${storeCode}&deviceCode=${deviceCode}`);
                        }
                    })
                } else {
                    toast.error("문제가 발생했습니다 관리자에게 문의하세요", {
                        autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                    });
                }
            })

        } else {
            toast.error("장바구니에 물건이 없습니다.", {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
        }

    }

    return (

        <div
            style={{
                backgroundColor: "#FFEADE",
                height: "100%",
            }}
        >
            <Dummy height={"50px"} />
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    zIndex: 99,
                    width: "100%",
                    height: "50px",
                    backgroundColor: "#F0F1F3"
                }}
            >
                <div style={{ width: "90%", margin: "0 auto", height: "50px" }}>
                    <HorizontalFlex>
                        <FlexChild width={"max-content"}>
                            <BackButton alignItems={"flex-start"} />
                        </FlexChild>
                        <FlexChild justifyContent={"center"}>
                            <P size={20} weight={700} font={"Pretendard"}>장바구니</P>
                        </FlexChild>
                        <FlexChild width={"max-content"} justifyContent={"flex-end"}>
                            <Center >
                                <div onClick={onSettingBtnClick}>
                                    <CustomIcon name={"setting"} width={"25px"} />
                                </div>
                            </Center>
                        </FlexChild>

                    </HorizontalFlex>
                </div>
            </div>
            <VerticalFlex flexStart gap={15}>
                <FlexChild
                    alignItems={"flex-start"}
                    justifyContent={"flex-start"}
                    height={"max-content"}

                >
                    {
                        Array.isArray(cartData) ? (
                            cartData.map((data, index) => {
                                return <MobileCartProductCard key={index} data={data} />;
                            })
                        ) : (
                            null // 또는 적절한 대체 UI 렌더링d
                        )
                    }
                    <Dummy height={"calc(10vh + 150px)"} />
                </FlexChild>
            </VerticalFlex>
            <div style={{
                borderTop: "1px solid black",
                position: "fixed",
                bottom: "9.5vh",
                zIndex: 99,
                height: "110px",
                backgroundColor: "white"
            }}>
                <VerticalFlex gap={5}>
                    <FlexChild >
                        <HorizontalFlex>
                            <FlexChild padding={"0 0 0 10px"}>
                                <Inline>
                                    <P>총 </P>
                                    <P>{cartData ? cartData.length : 0}건</P>
                                </Inline>
                            </FlexChild>
                            <FlexChild justifyContent={"flex-end"} padding={"0 10px 0 0"}>
                                {
                                    cartList.length > 0
                                        ? <P color={"black"} size={20} weight={"bold"} font={"Pretendard"}>
                                            &#8361;{total.toLocaleString()}
                                        </P>
                                        :
                                        <P color={"black"} size={20} weight={"bold"} font={"Pretendard"}>
                                            &#8361;0
                                        </P>
                                }
                            </FlexChild>
                        </HorizontalFlex>

                    </FlexChild>
                    <FlexChild>
                        <div
                            style={{
                                height: "45px",
                                backgroundColor: "#EC4715",
                                width: "95%",
                                // borderRadius: "20px",
                            }}
                            onClick={onPaymentClick}
                        >
                            <Center>
                                <P weight={"bold"} size={25} color={"white"} font={"Pretendard"}>
                                    결제하기
                                </P>
                            </Center>
                        </div>
                    </FlexChild>
                </VerticalFlex>
            </div>
        </div>
    );
}

export default MobileCartList;